<template>
    <Navbar/>

    <div class="container-fluid m-0 p-0">
        <div class="d-flex" style="height: 120vh">
            <Sidebar/>
            <main class="w-100 cssDesignSidebar">
                <router-view/>
            </main>
        </div>
    </div>

    <AlartModal v-if="successModal" :message="successMessage"    imagePath="okImage.svg" @close-modal="closeSuccessModalHandler"/>
    <AlartModal v-if="errorModal"   :message="errorMessage" imagePath="close.png" @close-modal="closeErrorModalHandler"/>
</template>

<script>
    import Navbar from "../components/Navbar";
    import Sidebar from "../components/Sidebar";
    import AlartModal from  "../components/AlartModal"
    import {computed} from "vue";
    import {useStore} from "vuex";

    export default {
        name: 'wrapper-page',
        components: {
            Navbar,
            Sidebar,
            AlartModal
        },

        setup(){
            const store = useStore();

            const closeSuccessModalHandler = async () => {
                await store.dispatch('setSuccessModal', false);
            };

            const closeErrorModalHandler = async () => {
                await store.dispatch('setErrorModal', false);
            };
            return{
                closeErrorModalHandler,
                closeSuccessModalHandler,
                successModal: computed(() => store.state.settings.successModal),
                errorModal: computed(() => store.state.settings.errorModal),
                successMessage: computed(() => store.state.settings.successMessage),
                errorMessage: computed(() => store.state.settings.errorMessage),
            }
        }
    }
</script>

<style>
    /*body {*/
    /*    background-image: linear-gradient(#044D6B, #021A24);*/
    /*}*/

    .cssDesignSidebar {
        /*margin: 30px 34px 24px 33px;*/
        overflow-y: auto;
        height: 88vh;
        padding: 0 20px 0 20px;
        /*margin-left: 13rem !important;*/
        /*margin-top: 1rem !important;*/
    }
</style>